import { Trans, useTranslation } from 'react-i18next'
import { ClaimDeviceForm } from '../components/forms/ClaimDeviceForm'
import { useAuth } from '../hooks/useAuth'
import { callAxios } from '../hooks/useAxios'
import { Device } from '../types/models'
import { PageText } from '../components/atoms/PageText'
import { TopTitle } from '../components/atoms/TopTitle'
import { Response } from '../types/api'
import { useNavigate } from 'react-router-dom'
import { useDevices } from '../hooks/useDevices'
import { useEffect, useState } from 'react'
import { Appliance } from '../classes/appliances/Appliance'
import { Dimming } from '../components/atoms/Dimming'

export function ClaimPage() {
  const { control } = useDevices()
  const { updateMe } = useAuth()
  const { t } = useTranslation()
  const navigate = useNavigate()
  const [devices, setDevices] = useState<Device[]>([])
  const [claiming, setClaiming] = useState(false)

  useEffect(() => {
    callAxios<Device[]>({
      url: '/devices',
    }).then(res => res.success && setDevices(res.data.filter(d => !d.values?.slave_of)))

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  const onSubmit = async (hwId: string | null): Promise<Response<Device>> => {
    setClaiming(true)
    const res = await callAxios<Device>({
      method: 'POST',
      url: '/devices/claim',
    }, { hw_id: hwId })

    if (res.success) {
      // Claiming is idempotent: re-adding a device that is already on the
      // account succeeds. Nothing changed then, so skip the multi-opt
      // reconfigure and the radio pairing step.
      const alreadyMine = devices.some(d => d.id === res.data.id)
      await updateMe()

      if (!alreadyMine) {
        try {
          const items = await Appliance.configureMultiOpt(control)
          await control.flashItems(items)
        } catch (e) {
          console.error('configureMultiOpt failed during claim:', e)
        }
        control.clearPendingConfig()
      }
      setClaiming(false)

      if (!alreadyMine && devices.length) {
        navigate(`/radio/${res.data.id}`)
      } else {
        navigate('/devices')
      }
    } else {
      setClaiming(false)
    }

    return res
  }

  return (
    <>
      <Dimming on={claiming}/>
      <TopTitle title={t('Add Device')}></TopTitle>
      <PageText sx={{ mb: '1.6rem' }}>
        <Trans>You will need your device's hardware ID.</Trans> <Trans>It is located on the side of your device.</Trans>
      </PageText>
      <ClaimDeviceForm onSubmit={onSubmit}/>
    </>
  )
}
